export function ModerationHistoryToolbar() {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">ປະຫວັດການກວດກາ</h2>
        <p className="text-muted-foreground text-sm">
          ລາຍການທີ່ຖືກເຊື່ອງ/ລຶບ/ເປີດຄືນ ແລະ ລາຍງານທີ່ດຳເນີນການ/ປິດແລ້ວ
        </p>
      </div>
    </div>
  );
}
